import {defineAsyncComponent} from 'vue'
const StatsRouter = [
  
    // 关键词每日数据
    {
      path: 'stats_keyword',
      name: 'StatsKeyword',
      component: () => import('@/views/Stats/StatsKeyword/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    // 关键词累计数据
    {
      path: 'stats_keyword_sum',
      name: 'StatsKeywordSum',
      component: () => import('@/views/Stats/StatsKeywordSum/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    // 博主累计数据
    {
      path: 'stats_data_blogger',
      name: 'StatsBlogger',
      component: () => import('@/views/Stats/StatsBlogger/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    // 平台累计数据
    {
      path: 'stats_newer_platform_sum',
      name: 'StatsPlatform',
      component: () => import('@/views/Stats/StatsPlatform/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    //团长每日统计
    {
      path: 'stats_data_director_daily',
      name: 'statsDirectorDaily',
      component: () => import('@/views/Stats/statsDirectorDaily/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    // 团长累计数据
    {
      path: 'stats_data_director',
      name: 'statsDirector',
      component: () => import('@/views/Stats/statsDirector/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
    // ActivityDatas
    {
      path: 'activity',
      name: 'ActivityDatas',
      component: () => import('@/views/ActivityDatas/Index.vue'),
      meta: {
        key: 'stats'
      },
    },
]
export {StatsRouter}
